import { memo, useCallback } from 'react';

import { type SearchSavedFiltersResponse } from '@air/api/types';
import { ChevronRightIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { SearchCommandItem } from '~/components/SearchCommand/SearchCommandItem';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type SearchCommandSavedFilterListItemProps = {
  savedFilter: SearchSavedFiltersResponse;
  onSelect: (savedFilter: SearchSavedFiltersResponse) => void;
};

export const SearchCommandSavedFilterListItem = memo(
  ({ savedFilter, onSelect: _onSelect }: SearchCommandSavedFilterListItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const onSelect = useCallback(() => _onSelect(savedFilter), [savedFilter, _onSelect]);

    return (
      <SearchCommandItem data-type="saved-filter" onSelect={onSelect} value={savedFilter.id}>
        <div className="flex size-10 shrink-0 items-center justify-center rounded-4 ads:bg-subtle bg-gray-4 text-20 transition-colors ads:group-data-[selected=true]/command-item:bg-hover-subtle group-data-[selected=true]/command-item:bg-gray-5">
          {savedFilter.icon}
        </div>

        <div className="min-w-0 grow px-1">
          <div className="truncate font-medium ads:text-primary text-14 text-gray-12">{savedFilter.name}</div>
        </div>
        <div
          className={cn(
            'flex size-8 shrink-0 items-center',
            ui2026 &&
              'opacity-0 group-hover/command-item:opacity-100 group-data-[selected=true]/command-item:opacity-100',
          )}
        >
          <ChevronRightIcon className="w-4 ads:text-icon-emphasis text-gray-12" />
        </div>
      </SearchCommandItem>
    );
  },
);

SearchCommandSavedFilterListItem.displayName = 'SearchCommandSavedFilterListItem';
